<template>
    <div>
        <settings-item :label="resource('JourneyComposer_ABTest_Route_Description_DisplayName')">
            <template #input="{id}">
                <input :id="id"
                       class="form-control"
                       v-model="descriptionModel"
                       
                       :disabled="!canWrite"
                />
            </template>
        </settings-item>

        <settings-item :label="resource('JourneyComposer_ABTest_Route_Color_DisplayName')">
            <template #input>
                <color-picker
                    @change-color="colorModel = $event"
                    :color="colorModel"
                    
                    :enabled="canWrite"
                />
            </template>
        </settings-item>

        <settings-item icon="fas fa-percentage" :label="resource('JourneyComposer_ABTest_Route_Percentage_DisplayName')">
            <template #input="{id}">
                <input :id="{id}"
                       class="form-control"
                       type="number"
                       v-model="percentageModel"

                       step="1"
                       
                       min="1"
                       max="100"

                       :disabled="!canWrite"
                />
            </template>

            <template #errors v-if="$v.percentageModel.$invalid && $v.percentageModel.$dirty">
                <min-value-error-message 
                    v-if="!$v.percentageModel.minValue" 
                    :field-name="resource('JourneyComposer_ABTest_Route_Percentage_DisplayName')" 
                    :min-value="1" 
                />
                
                <max-value-error-message 
                    v-if="!$v.percentageModel.maxValue" 
                    :field-name="resource('JourneyComposer_ABTest_Route_Percentage_DisplayName')" 
                    :max-value="100" 
                />
            </template>
        </settings-item>
    </div>
</template>

<script>
import {guid} from "@core/Util/guid";
import {maxValue, minValue} from 'vuelidate/lib/validators';

import permissionMixin from "@modules/JourneyBuilder/Mixins/journey-permissions";
import resourceMixin from "@core/Util/Mixins/resources";
import {validationMixin} from 'vuelidate';

import SettingsProperty from "../SettingsProperty";
import ColorPicker from "@core/Components/Util/ColorPicker";
import MaxValueErrorMessage from "@core/Components/Errors/MaxValueErrorMessage";
import MinValueErrorMessage from "@core/Components/Errors/MinValueErrorMessage";

export default {
    name: "ABTestCondition",
    components: {
        SettingsItem: SettingsProperty,
        ColorPicker,
        MaxValueErrorMessage,
        MinValueErrorMessage
    },
    mixins: [permissionMixin, resourceMixin, validationMixin],
    validations: {
        percentageModel: {
            minValue: minValue(1),
            maxValue: maxValue(100)
        }
    },
    computed: {
        percentageModel: {
            get(){
                return this.percentage;
            },
            set(value){
                value = parseInt(value);
                
                //Prevent invalid values from being used
                if(isNaN(value)){
                    value = 1;
                }
                
                //https://datanext.atlassian.net/browse/DPN-3575
                //Don't accept decimal values - attempt to strip anything post decimal
                value = Math.round(value);
                
                //Guard against invalid ranges
                value = Math.max(1, value);
                value = Math.min(100, value);
                
                this.$v.percentageModel.$touch();
                this.$emit('update:percentage', value);
            }
        },
        colorModel: {
            get(){
                return this.color;
            },
            set(value){
                this.$emit('update:color', value);
            }
        },
        descriptionModel: {
            get(){
                return this.description;
            },
            set(value){
                this.$emit('update:description', value);
            }
        }
    },
    props: {
        percentage: Number,
        color: String,
        description: String
    }
}
</script>
